// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { Separator } from '../../../commons/atoms';

type Props = {|
  title?: Node,
  children?: Node,
|};

export function InstructionsText({ title, children }: Props): Node {
  return (
    <Root>
      <InstructionsTitle>{title}</InstructionsTitle>
      <Separator direction="vertical" size={2} />
      {children}
    </Root>
  );
}

const Root = styled.div`
  margin-bottom: 16px;
  font-weight: 400;
  text-align: center;
`;

const InstructionsTitle = styled.p`
  font-size: 18px;
  color: #828d9d;
`;
